var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-left" },
    [
      _vm.label && !_vm.hideLabel
        ? _c(
            "label",
            {
              staticClass: "text-brand-secondary",
              class: { "text-xl md_text-base": _vm.labelLarge }
            },
            [
              _vm._v(_vm._s(_vm.label) + " "),
              _vm.optional
                ? _c("span", { staticClass: "text-brand-secondary-100" }, [
                    _vm._v("(optional)")
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "relative" },
        [
          _vm.type === "search"
            ? _c(
                "svg",
                {
                  staticClass: "absolute svg right-1 cursor-pointer",
                  class: _vm.white ? "text-white" : "text-brand",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "17",
                    height: "17",
                    viewBox: "0 0 20 20"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("search", {
                        target: { value: _vm.value }
                      })
                    }
                  }
                },
                [
                  _c("path", {
                    staticClass: "fill-current",
                    attrs: {
                      d:
                        "M1.193 8.523c0-4.042 3.294-7.326 7.337-7.326 4.048 0 7.337 3.289 7.337 7.326 0 4.037-3.289           7.33-7.337 7.33-4.043 0-7.337-3.289-7.337-7.33zM19.827 18.98l-4.861-4.86a8.492 8.492 0 0 0 2.093-5.592C17.06           3.823 13.231 0 8.53 0 3.824 0 0 3.827 0 8.528c0 4.7 3.828 8.527 8.53 8.527 2.138 0 4.094-.789           5.593-2.093l4.861 4.86c.116.116.27.178.422.178a.6.6 0 0 0 .421-1.02z"
                    }
                  })
                ]
              )
            : _vm.type === "email-offers"
            ? _c(
                "svg",
                {
                  staticClass:
                    "absolute svg right-1_5 md_right-1 cursor-pointer svg--email",
                  class: _vm.white ? "text-white" : "text-brand",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 29 25"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("search", {
                        target: { value: _vm.value }
                      })
                    }
                  }
                },
                [
                  _c("path", {
                    staticClass: "fill-current",
                    attrs: {
                      d: "M0 25l29-12.5L0 0v9.722L20.714 12.5 0 15.278z"
                    }
                  })
                ]
              )
            : _vm.helpHtml
            ? _c("vs-help", {
                staticClass: "svg absolute right-1",
                attrs: {
                  "no-margin-bottom": "no-margin-bottom",
                  message: _vm.helpHtml
                }
              })
            : _vm.helpHtml
            ? _c(
                "svg",
                {
                  staticClass: "h-1 w-1 absolute right-1 svg",
                  class: _vm.white ? "text-white" : "text-brand",
                  attrs: { viewBox: "0 0 24 24" }
                },
                [
                  _c("path", {
                    staticClass: "fill-current",
                    attrs: {
                      d:
                        "M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"
                    }
                  })
                ]
              )
            : _vm._e(),
          _c("input", {
            staticClass: "buyer-text-input w-full focus_outline-none",
            class: _vm.classes,
            attrs: {
              type: _vm.inputType,
              "aria-label": _vm.label || _vm.placeholder,
              "aria-describedby": _vm.errorIds.length
                ? _vm.errorIds.join(" ")
                : null,
              "aria-invalid": _vm.errorIds.length ? "true" : "false",
              "aria-disabled": _vm.disabled ? "true" : "false",
              placeholder: _vm.placeholder,
              autocomplete: _vm.autocomplete
            },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event)
              },
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.$emit("search", { target: { value: _vm.value } })
              },
              blur: _vm.handleBlur
            }
          })
        ],
        1
      ),
      _vm.error && _vm.errorIds.length
        ? _c(
            "div",
            {
              staticClass: "mt-_5 text-error text-sm",
              attrs: { id: _vm.errorIds[0] }
            },
            [_vm._v(_vm._s(_vm.error))]
          )
        : _vm.visibleErrors.length
        ? _vm._l(_vm.visibleErrors, function(error, index) {
            return _c(
              "div",
              {
                key: _vm.errorIds[index],
                staticClass: "mt-_5 text-error text-sm",
                attrs: { id: _vm.errorIds[index] }
              },
              [_vm._v(_vm._s(error.text))]
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }